import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ConfirmationModal(props) {
    var modalTitle;
    var modalBody;
    var modalshow;

    if (props.stateProps.modalName === 'deletConfirmModal') {
        modalTitle = "Delete Confirmation";
        modalBody = "Are you sure want to delete?";
        modalshow = props.stateProps.show;
    }
    else if (props.stateProps.modalName === 'discardScanConfirmModal') {
        modalTitle = "Discard Scan Confirmation";
        modalBody = "Are you sure want to discard the scans?";
        modalshow = props.stateProps.showconfirmationmodal;
    }
    else if (props.stateProps.modalName === 'UndiscardScanConfirmModal') {
        modalTitle = "Restore Scan Confirmation";
        modalBody = "Are you sure want to restore the scans?";
        modalshow = props.stateProps.showundiscardconfirmationmodal;
    }
    else if (props.stateProps.modalName === 'informationModal') {
        modalTitle = "Delete Unsuccessful";
        modalBody = "The selected study cannot be deleted because at least one scan is assigned to it.";
        modalshow = props.stateProps.show;
    }
    else if (props.stateProps.modalName === 'taginformationModal') {
        modalTitle = "Delete Unsuccessful";
        modalBody = "Existing tags cannot be deleted.";
        modalshow = props.stateProps.show;
    }
    else if (props.stateProps.modalName === 'changeLockStatusModal') {
        modalTitle = "Unlock account";
        modalBody = "Are you sure want to update lockstatus of account?";
        modalshow = props.stateProps.show;
    }

    else {
        modalTitle = "Update Confirmation";
        modalBody = "Are you sure want to update?";
        modalshow = props.stateProps.show;
    }
    const handleClose = (e) => {
        props.handleClose();
    }

    const confirmMethod = (e) => {
        props.handleClose();
        if (props.stateProps.modalName === 'deletConfirmModal')
            props.confirmDelete();
        else if (props.stateProps.modalName === 'discardScanConfirmModal')
            props.DiscardScans();
        else if (props.stateProps.modalName === 'UndiscardScanConfirmModal')
            props.UnDiscardScans();
        else if (props.stateProps.modalName === 'informationModal') {
            props.handleClose();
        }
        else if (props.stateProps.modalName === 'taginformationModal') {
            props.handleClose();
        }
        if (props.stateProps.modalName === 'changeLockStatusModal')
            props.confirmChangeLockStatus();
        else
            props.confirmUpdate(props.stateProps.rownmber);
    }

    return (

        <Modal show={modalshow} onHide={handleClose} style={{ opacity: 1 }}>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{modalBody}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" id="okBtnId" onClick={confirmMethod}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>

    );
}

export default ConfirmationModal;